import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

export interface TermsModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  contentLines: string[]; // lines already split by <br/>
}

const TermsModal: React.FC<TermsModalProps> = ({ open, onClose, title = 'Terms and Conditions', contentLines }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      {/* Sticky Title */}
      <DialogTitle
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 2,
          backgroundColor: 'background.paper',
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        {title}
      </DialogTitle>

      {/* Scrollable Content */}
      <DialogContent
        dividers
        sx={{
          maxHeight: '60vh',
          overflowY: 'auto',
          backgroundColor: 'background.paper',
        }}
      >
        <Typography variant="body1" component="div">
          {contentLines.map((line, idx) => (
            <span key={idx} dangerouslySetInnerHTML={{ __html: line + (idx < contentLines.length - 1 ? '<br />' : '') }} />
          ))}
        </Typography>
      </DialogContent>

      {/* Sticky Actions */}
      <DialogActions
        sx={{
          position: 'sticky',
          bottom: 0,
          zIndex: 2,
          backgroundColor: 'background.paper',
          borderTop: 1,
          borderColor: 'divider',
          justifyContent: 'center',
        }}
      >
        <Button onClick={onClose} variant="contained">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsModal;
